import { WebsocketConfig } from './configs/websocket.config';
import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebsocketProvider } from './interfaces/websocket-provider.interface';
import {
  ConnectionData,
  WEBSOCKET_CONNECTION_DATA,
  WEBSOCKET_IMPLEMENTATION_CLASS
} from './providers/web-socket-connection.provider';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SocketIdInterceptor } from './interceptors/socket-id.interceptor';

export interface CapturumWebsocketModuleConfig {
  websocketDriver: Type<WebsocketProvider>;
  connectionConfig: ConnectionData;
  endpoint: string;
}

// @dynamic
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
  ],
})
export class CapturumWebsocketModule {
  public static forRoot(config: CapturumWebsocketModuleConfig): ModuleWithProviders<CapturumWebsocketModule> {
    return {
      ngModule: CapturumWebsocketModule,
      providers: [
        {
          provide: WEBSOCKET_CONNECTION_DATA,
          useValue: config.connectionConfig,
        },
        {
          provide: WEBSOCKET_IMPLEMENTATION_CLASS,
          useClass: config.websocketDriver,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: SocketIdInterceptor,
          multi: true,
        },
        WebsocketConfig,
      ],
    };
  }
}
